<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topImage">
      <img lazy-load :src="data.insuranceProduct.bigImage">
    </div>
    <div v-if="data && data.baseInfo" class="titleRect">
      <div class="title">{{ data.baseInfo.productName }} {{ data.baseInfo.planName }}</div>
      <div class="comLogo"><img lazy-load :src="data.baseInfo.bigLogo"></div>
      <div class="price" :style="'color:'+GetColorMainBack()"><span>￥</span>{{ ShowMoneySpan(data.baseInfo.price*0.01,true) }}.<span>{{ ShowMoneySpan(data.baseInfo.price*0.01,false) }}</span></div>
      <div class="tagList">
        <span v-for="(item,index) in tagList" :key="index">
          {{ item }}
        </span>
      </div>
    </div>
    <div v-if="data.baseInfo.features" class="tagTitleList">
      <span v-for="(item,index) in data.baseInfo.features" :key="index" class="rect">
        <i class="iconfont iconquanyi" :style="'color:'+GetColorMainBack()" /> <span v-html=" item.content" />
      </span>
    </div>
    <div class="baseRect planRect" style="margin-top: 0;">
      <div class="baseRectTitle">保障方案</div>
      <van-tabs v-if="data.other && data.other.length>1" v-model="insuranceProductId" class="planSelect" :ellipsis="false" @change="onPlanChange">
        <van-tab v-for="item in data.other" :key="item.insuranceProductId" :name="item.insuranceProductId" :title="item.planName" />
      </van-tabs>
      <template v-for="(item,index) in data.baseInfo.protectItems">
        <div v-if="showAllProtect || (!showAllProtect && index<6)" :key="index" class="planLine" @click="onShowNotice(item.name,'保障金额:'+item.defaultValue+'<br>'+item.description)">
          <van-row>
            <van-col span="14">  {{ item.name }}</van-col>
            <van-col span="8" offset="2" class="rigth">  {{ item.defaultValue }}<i class="iconfont iconrigthjt" /></van-col>
          </van-row>
        </div>
      </template>
      <div v-if="!showAllProtect && data.baseInfo.protectItems.length>6" class="planLine center more" @click="showAllProtect=true">
        查看更多<i class="iconfont icondownjt" />
      </div>
    </div>
    <div v-if="data.baseInfo.droits" class="baseRect droitRect">
      <div class="baseRectTitle">您的权利</div>
      <div v-for="(item,index) in data.baseInfo.droits" :key="index" class="droitLine">
        <div class="title"><i class="iconfont iconquanyi" />{{ item.name }}</div>
        <div class="about">{{ item.description }}</div>
      </div>
    </div>
    <div v-if="data.baseInfo.insuranceCase" class="baseRect">
      <div class="baseRectTitle">投保案例</div>
      <div class="CaseRect" v-html="data.baseInfo.insuranceCase" />
    </div>
    <div v-if="data.baseInfo.faqs" class="baseRect">
      <div class="baseRectTitle">常见问题</div>
      <div class="QARect">
        <div v-for="(item,index) in data.baseInfo.faqs" :key="index" class="QALine">
          <van-row gutter="30">
            <van-col span="1"><i class="iconfont iconwen" /></van-col>
            <van-col span="21" v-html="item.question" />
          </van-row>
          <van-row gutter="30">
            <van-col span="1"><i class="iconfont iconda" /></van-col>
            <van-col span="21" v-html="item.answer" />
          </van-row>
        </div>
      </div>
    </div>
    <div v-if="data.baseInfo.tips" class="baseRect">
      <div class="baseRectTitle">投保须知</div>
      <div class="tipsRect">
        <p class="tipsList">
          <b>1.&nbsp;</b>投保前请您仔细阅读：
          <a :style="'color:'+GetColorMainBack()" href="#provisions">《产品条款》</a>
          <a v-if="data.baseInfo.premiumTable" :style="'color:'+GetColorMainBack()" @click="onViewPdf(data.baseInfo.premiumTable)">《费率表》</a>
          <a v-if="data.baseInfo.claimsRatios" :style="'color:'+GetColorMainBack()" href="#claimsRatios">《保险金赔付比例》</a>
          <a v-if="data.baseInfo.pictureNotify" :style="'color:'+GetColorMainBack()" @click="onViewPdf(data.baseInfo.pictureNotify)">《客户告知书》</a>
          <a v-if="data.baseInfo.samplePolicy" :style="'color:'+GetColorMainBack()" @click="onViewPdf(data.baseInfo.samplePolicy)">《保险样本》</a>
        </p>
        <p class="tipsList">
          <b>2.&nbsp;免除责任、保障责任、犹豫期、费用扣除、退保、保险单现金价值、投保人、被保险人义务等内容详见产品条款，请务必仔细阅读
            <a :style="'color:'+GetColorMainBack()" href="#provisions">《产品条款》</a>
            及电子保单的特别约定。
          </b>
        </p>
        <p v-for="(item,index) in data.baseInfo.tips" :key="index" class="tipsList">
          <b>{{ index+3 }}.&nbsp;</b><span v-html="item" />
        </p>
      </div>
    </div>
    <div v-if="data.baseInfo.masterProvisions || data.baseInfo.additionalProvisions" id="provisions" class="baseRect">
      <div class="baseRectTitle">保险条款</div>
      <div v-if="data.baseInfo.masterProvisions" class="provisionRect">
        <div class="title">主条款</div>
        <div v-for="(item,index) in data.baseInfo.masterProvisions" :key="index" class="provisionLine" @click="onShowNotice(item.title,item.content,item.htmlAttachmentUrl)">
          <van-row gutter="30">
            <van-col span="21">  {{ item.title }}</van-col>
            <van-col span="3" class="rigth"><i class="iconfont iconrigthjt" /></van-col>
          </van-row>
        </div>
      </div>
      <div v-if="data.baseInfo.additionalProvisions" class="provisionRect">
        <div class="title">附加条款</div>
        <div v-for="(item,index) in data.baseInfo.additionalProvisions" :key="index" class="provisionLine" @click="onShowNotice(item.title,item.content,item.htmlAttachmentUrl)">
          <van-row gutter="30">
            <van-col span="21">  {{ item.title }}</van-col>
            <van-col span="3" class="rigth"><i class="iconfont iconrigthjt" /></van-col>
          </van-row>
        </div>
      </div>
      <div v-if="data.baseInfo.claimsRatios" id="claimsRatios" class="provisionRect">
        <div class="title">保险金赔付比例</div>
        <div v-for="(item,index) in data.baseInfo.claimsRatios" :key="index" class="provisionLine" @click="onShowNotice(item.title,item.content,item.htmlAttachmentUrl)">
          <van-row gutter="30">
            <van-col span="21">  {{ item.title }}</van-col>
            <van-col span="3" class="rigth"><i class="iconfont iconrigthjt" /></van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="aboutBody" v-html="data.baseInfo.productRead" />
    <div class="downEmpty" />
    <div class="downButtonRect">
      <van-row>
        <van-col span="16" class="priceRect">
          <div :style="'color:'+GetColorMainBack()">
            <span>￥</span>{{ ShowMoneySpan(data.baseInfo.price*0.01,true) }}.<span>{{ ShowMoneySpan(data.baseInfo.price*0.01,false) }}</span>
          </div>
        </van-col>
        <van-col span="8"><van-button :color="GetColorMainBack()" size="large" style="width:100%;height:3em;line-height:3em" @click="showBuySelect = data">立即投保</van-button></van-col>
      </van-row>

    </div>
    <van-popup v-model="showNotice" position="bottom" class="noticeRect">
      <div class="title">
        <van-row>
          <van-col span="3" />
          <van-col span="18" class="center">{{ noticeTitle }}</van-col>
          <van-col span="3" class="rigth"><i class="iconfont iconclosex" @click="showNotice=false" /></van-col>
        </van-row>
      </div>
      <div class="bodys">
        <div v-html="noticeBody" />
      </div>
    </van-popup>
    <buySelect v-model="showBuySelect" @onbuy="onBuy" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Lazyload, Tab, Tabs, Popup } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoneySpan, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import buySelect from '@/views/insurance/buySelect'
export default {
  components: {
    [Button.name]: Button,
    [Lazyload.name]: Lazyload,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    TopBar,
    buySelect
  },
  data() {
    return {
      titleTop: '',
      title: '我的保险',
      backurl: '/store/index',
      insuranceProductId: undefined,
      loading: true,
      data: {
        baseInfo: {
          protectItems: []
        },
        insuranceProduct: {}
      },
      tagList: [],
      showAllProtect: false,
      showNotice: false,
      noticeTitle: undefined,
      noticeBody: undefined,
      showBuySelect: undefined,
      paramsType: undefined,
      paramsTypeId: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.load(this.$route.params.id)
    this.paramsType = getUrlKey('type')
    this.paramsTypeId = getUrlKey('typeid')
  },
  activated() {
  },
  methods: {
    getUrlKey,
    ShowMoneySpan,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    load(id) {
      if (this.insuranceProductId) {
        var url = '/insurance/info/' + this.insuranceProductId
        if (this.paramsType && this.paramsTypeId) {
          url += '?type=' + this.paramsType + '&typeid=' + this.paramsTypeId
        }
        this.$router.push(url)
      }
      this.insuranceProductId = id
      this.init(() => {

      })
    },
    init(callback) {
      this.tagList = []
      this.loading = true
      this.showAllProtect = false
      request({
        url: '/Insurance/GetInsuranceProduct',
        method: 'post',
        params: { id: this.insuranceProductId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.processDataYear()
        this.processDataDate()
        this.loading = false
        if (callback) {
          callback()
        }
      })
    },
    processDataDate() {
      var config = this.data.baseInfo.restrictGenes.filter(item => item.key === 'insurantDateLimit')
      if (config.length > 0) {
        config = config[0]
        if (config.values.length <= 1) {
          this.tagList.push('保障期限:' + config.values[0].value + config.values[0].unit)
        } else {
          this.tagList.push('保障期限:' + config.values[0].value + config.values[0].unit + '~' +
            config.values[config.values.length - 1].value + config.values[config.values.length - 1].unit + '可选')
        }
      }
    },
    processDataYear() {
      // 处理保障年龄计算
      var config = this.data.baseInfo.restrictGenes.filter(item => item.key === 'insurantDate')
      if (config.length > 0) {
        config = config[0]
        var minValue = 100
        var maxValue = 0
        var minYearEnbale = false
        var maxYearEnable = false
        var unitStr = ''
        config.values.forEach(item => {
          if (item.min < minValue) {
            minValue = item.min
            minYearEnbale = true
            unitStr = item.unit
          }
          if (item.max > maxValue) {
            maxValue = item.max
            maxYearEnable = true
            unitStr = item.unit
          }
        })
        var moreStr = ''
        if (config.values.length > 1) {
          moreStr = '可选'
        }
        if (minYearEnbale && maxYearEnable) {
          this.tagList.push('承保年龄:' + minValue + '~' + maxValue + unitStr + moreStr)
        } else if (minYearEnbale) {
          this.tagList.push('承保年龄:大于' + minValue + unitStr + moreStr)
        } else {
          this.tagList.push('承保年龄:小于' + minValue + unitStr + moreStr)
        }
      }
    },
    onPlanChange(name, title) {
      console.log('onPlanChange', name)
      console.log('onPlanChange', title)
      this.load(name)
    },
    onViewPdf(fileUrl) {
      console.log('onViewPdf', fileUrl)
    },
    onShowNotice(title, body,htmlUrl) {
      this.showNotice = true
      this.noticeTitle = title
      if(body&&!htmlUrl){
        this.noticeBody = body
      }else if(htmlUrl)
      {
        this.noticeBody ='加载中'
        window.location.href = htmlUrl
      }else 
      {
        this.noticeBody ='暂无内容'
      }
      
    },
    onBuy(config, price) {
      console.log('onBuy', config)
      var params = ''
      var extMap = {}
      config.forEach(item => {
        if (item.key === 'insurantDateLimit') {
          var line = item.values.filter(el => el.value + el.unit === item.select)
          if (line.length > 0) {
            var day = 1
            if (typeof (line[0].value) !== 'string') {
              day = line[0].value
            } else {
              day = line[0].max
            }
            if (line[0].unit === '年') {
              day = day * 365
            }
            params += 'day=' + day + '&'
          }
        }
      })
      // 计算扩展参数
      config.forEach(item => {
        if (item.name === '旅行延误是否升级') {
          extMap['旅行延误是否升级'] = item.select
        } else if (item.key) {
          extMap[item.key] = item.select
        } else {
          extMap[item.protectItemId] = item.select
        }
      })
      var dataStr = encodeURIComponent(JSON.stringify(extMap))

      var url = '/insurance/create/' + this.insuranceProductId + '?price=' + price + '&extMap=' + dataStr + '&' + params
      if (this.paramsType && this.paramsTypeId) {
        url += '&type=' + this.paramsType + '&typeid=' + this.paramsTypeId
      }
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.topImage{
  width: 100vw;
  min-height: 3em;
}
.topImage img{
  width: 100vw;
}
.titleRect{
  background-color: #fff;
  padding: 1em;
  position: relative;
}
.titleRect .title{
  padding-right: 20vw;
  font-weight: 700;
}
.titleRect .comLogo{
  position:absolute;
  right: 1em;
  top: 1em;
  width: 15vw;
}
.titleRect .comLogo img{
  width: 100%;
}
.titleRect .price{
  font-size: 1.7em;
  line-height: 1.9em;
}
.titleRect .price span{
  font-size: 0.7em;
}
.titleRect .tagList{
  font-size: 0.8em;
}
.titleRect .tagList span{
  border-right: 1px solid #ccc;
  padding: 0 0.5em;
}
.titleRect .tagList span:first-child{
  padding-left: 0;
}
.titleRect .tagList span:last-child{
  border-right: none;
}

.tagTitleList{
  font-size: 0.8em;
  padding: 1em;
  color: #333;
}
.tagTitleList .rect{
  padding-right: 1em;
  line-height: 1.7em;
}
.tagTitleList span i{
  padding-right: 0.25em;
}

.baseRect{
  background-color: #fff;
  padding: 1em;
  margin-top: 1em;
}
.baseRect .baseRectTitle{
  padding-bottom: 1em;
  font-weight: 700;
  font-size: 0.9em;
}
.planRect .planLine{
  border:1px solid #f5f5f5;
  border-top: none;
  font-size: 0.8em;
  padding: 0.75em 0.5em;
}
.planRect .planSelect{
  border-left:1px solid #f5f5f5;
  border-right:1px solid #f5f5f5;
}
.planRect .planLine i{
  padding-left: 0.25em;
  color: #999;
}
.planRect .more{
  color:#999;
}
.aboutBody{
  background-color: #fff;
  width: 100vw;
}
.droitLine{
    border:1px solid #f5f5f5;
    border-bottom: none;
    padding: 0.5em;

}
.droitRect:last-child{
  border-bottom:1px solid #f5f5f5;
}
.droitLine .title{
  font-size: 0.9em;
  padding-bottom: 0.5em;
}
.droitLine .about{
  font-size: 0.8em;
  color: #999;
}
.droitLine i{
  padding-right: 0.5em;
}
.CaseRect{
  border:1px solid #f5f5f5;
  padding:0.5em;
  font-size: 0.8em;
   line-height: 1.7em;
}
.QARect{
  border:1px solid #f5f5f5;
  padding:0.5em;
  font-size: 0.8em;
  line-height: 1.7em;
}
.QARect .QALine{
  border-bottom:1px dotted  #f5f5f5;
  padding-bottom: 0.5em;
  margin-bottom: 0.5em;
}

.tipsRect{
  border:1px solid #f5f5f5;
  padding:0 0.5em;
}

.tipsRect .tipsList{
  font-size: 0.8em;
  line-height: 1.7em;
}

.provisionRect{
  border:1px solid #f5f5f5;
  padding:0 0.5em;
}
.provisionRect .title{
  font-size: 0.9em;
  font-weight: 700;
  line-height: 2em;
}
.provisionRect .provisionLine{
  font-size: 0.8em;
  line-height: 1.7em;
  padding: 0.4em 0;
}

.noticeRect{

}
.noticeRect .title{
  font-weight: 700;
  padding: 0.5em 1em;
}
.noticeRect .bodys{
  max-height: 80vh;
  min-height: 30vh;
  padding: 0 1em;
  overflow-y: scroll;
}
.noticeRect .bodys div{
  line-height: 1.7em;
  font-size: 0.8em;
  color: #999;
  padding-bottom: 1em;
}

.downEmpty{
  height: 3em;
}
.downButtonRect {
  height: 3em;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
}
.downButtonRect .priceRect{
  line-height: 3em;
  padding-left: 1em;
}
.downButtonRect .priceRect div{
  font-size: 1.7em;
}
.downButtonRect .priceRect div span{
  font-size: 0.7em;
}
</style>
<style>
.aboutBody img{
  max-width:  100vw;
}
</style>
